/* The Dom Home · botón «Añadir gratis» del regalo con compras de 100 € */
(() => {
  if (window.__dhGift) return;
  window.__dhGift = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('change', (e) => {
    const select = e.target.closest && e.target.closest('[data-dh-gift-select]');
    if (!select) return;
    const card = select.closest('[data-dh-gift-card]');
    const btn = card && card.querySelector('[data-dh-gift-add]');
    if (btn) btn.dataset.variant = select.value;
    const img = select.selectedOptions[0] && select.selectedOptions[0].dataset.img;
    const el = card && card.querySelector('img');
    if (img && el) el.src = img;
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest && e.target.closest('[data-dh-gift-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    const label = btn.textContent;
    btn.textContent = '…';

    const ids = [...new Set(
      [...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId)
    )];

    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.variant), quantity: 1, properties: { _regalo: '1' } }],
          sections: ids.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw data;

      const cart = await (await fetch(root + 'cart.js')).json();
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'dh-gift',
            data: { source: 'dh-gift', itemCount: cart.item_count, sections: data.sections },
          },
        })
      );
      if (!ids.length) window.location.reload();
    } catch (err) {
      console.error('[dh-gift]', err);
      btn.disabled = false;
      btn.textContent = btn.dataset.err || label;
      setTimeout(() => { btn.textContent = label; }, 2500);
    }
  });
})();
